<template lang="pug">
  div(
    v-if="solicitacao"
  )
    .card-container
      p.historico-label Mensagem {{ solicitacao.numero }}
      .label-descricao
        span.negrito Descrição:
        span.space-left {{ solicitacao.descricao || '-' }}
      .cartorio-pesquisa
        el-collapse(value="0", v-model="collapseActive")
          el-collapse-item(
            name="0"
          )
            template(slot="title")
              div.container-title-collapse
                div
                  span.nome-collpase {{ ORIGEM[solicitacao.mensagemCartorios[0].origem] }}
                  span {{ ' - ' + solicitacao.mensagemCartorios[0].remetente.nome }}
                div.data-collapse {{ titleCollapseMensagemData(solicitacao.mensagemCartorios[0]) }}
            visualizar-mensagem(:mensagem="solicitacao.mensagemCartorios[0]", :solicitacao="solicitacao", :ultima="true")
      el-row(v-if="solicitacao.mensagemCartorios.length > 1")
        el-col(:lg="24", :md="24", :sm="24")
          p.historico-label Histórico
          div(v-for="(item, index) in solicitacao.mensagemCartorios")
            .cartorio-pesquisa(v-if="index !== 0")
              el-collapse(:value="index" @change="openCollapse")
                el-collapse-item(name="collapsed")
                  template(slot="title")
                    div.container-title-collapse
                      div
                        span.nome-collpase {{ ORIGEM[item.origem] }}
                        span {{ ' - ' + item.remetente.nome }}
                      div.data-collapse {{ titleCollapseMensagemData(item) }}
                  visualizar-mensagem(
                    :mensagem="item",
                    :solicitacao="solicitacao"
                  )
    el-col.container-buttons(:lg="24", :md="24", :sm="24")
      el-button(class="btn-voltar", @click="voltar")
        i.fas.fa-chevron-left
        span.space-left Voltar
      div
        el-button(class="btn-info", @click="goResponder", v-if="solicitacao.status !== 'FINALIZADA' && solicitacao.status === 'AGUARDANDO_RESPOSTA_SICARF'") Responder
        el-button(class="btn-success", @click="finalizar", v-if="solicitacao.status !== 'FINALIZADA' && solicitacao.origem === 'SICARF' && solicitacao.status !== 'AGUARDANDO_RESPOSTA_SICARF'")
          i.fas.fa-check
          span.space-left Finalizar
</template>

<script>
import VisualizarMensagem from '../components/VisualizarMensagem'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import {
  TIPO_MENSAGEM,
  STATUS_MENSAGEM,
  ORIGEM
} from '@/constants/cartoriosArrecadacao'
import { mapActions } from 'vuex'
import BaseAnaliseProcessos from '../mixins/BaseAnaliseProcessos'

export default {
  name: 'Visualizar',

  components: {
    VisualizarMensagem
  },

  mixins: [AppNotificacao, BaseAnaliseProcessos],

  props: ['routeListagemName', 'hasProcesso'],

  data () {
    return {
      TIPO_MENSAGEM,
      STATUS_MENSAGEM,
      ORIGEM,
      solicitacao: {},
      collapseActive: ['0'],
      protocolo: null,
      idProcesso: null
    }
  },

  mounted () {
    this.protocolo = this.$route.query.protocolo
    this.idProcesso = this.$route.query.idProcesso
    this.getSolicitacao()
  },

  methods: {
    ...mapActions({
      findSolicitacaoByProtocolo:
        'cartorioArrecadacao/findSolicitacaoByProtocolo',
      visualizado: 'cartorioArrecadacao/visualizado',
      finalizarSolicitacao: 'cartorioArrecadacao/finalizar'
    }),

    async getSolicitacao () {
      this.solicitacao = JSON.parse(
        await this.findSolicitacaoByProtocolo(this.protocolo)
      )
    },

    async finalizar () {
      this.confirmBox(
        this.$messages.FINALIZAR_SOLICITACAO,
        this.$messages.TITULO_WARNING,
        async () => {
          await this.finalizarSolicitacao(this.solicitacao.id)
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            'Finalizada com sucesso.'
          )
          this.goToListagem()
        },
        () => {}
      )
    },

    goResponder () {
      this.$router.push({
        name: 'responder',
        query: {
          idSolicitacao: this.solicitacao.id,
          idProcesso: this.idProcesso
        }
      })
    },

    voltar () {
      this.goToListagem()
    },

    titleCollapseMensagemData (mensagem) {
      return 'Data de envio: ' + mensagem.data
    },

    async openCollapse (item) {
      if (!this.solicitacao.mensagemCartorios[item[0]].dataVisualizacao) {
        await this.setVisualizado(item[0])
      }
    },

    async setVisualizado (index) {
      this.solicitacao.mensagemCartorios[index] = await this.visualizado(
        this.solicitacao.mensagemCartorios[index].id
      )
    }
  }
}
</script>

<style lang="scss">
.app {
  display: flex;
  flex-direction: column;
  margin: 20px;
}

.card-container {
  border: 1px solid #ebeef5 !important;
}

h1 .titulo {
  font-size: 50px !important;
}

.container-title-collapse {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 95%;
}

.nome-collpase {
  text-transform: uppercase;
}

.data-collapse {
  font-size: 14px;
  color: gray;
}

.label-descricao {
  display: flex;
  flex-direction: row;
  margin: 20px;
}

.negrito {
  font-weight: bold;
}

.space-left {
  margin-left: 5px;
}

.top30 {
  margin-top: 30px !important;
}

.historico-label {
  font-size: 18px;
  font-weight: bold;
  color: #606266;
  margin: 20px !important;
}

.container-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  padding-bottom: 20px;
}

.container-buttons .el-button {
  height: 35px;
}

.container-buttons .btn-voltar {
  min-width: 120px;
  padding: 8px 10px;
}

.container-buttons .btn-success {
  background: #009f61;
  color: #fff;
  cursor: pointer;
  padding: 8px 10px;
  font-size: 14px;
  border: none #009f61;
  border-radius: 5px;
  min-width: 120px;
}

.container-buttons .btn-success:hover {
  color: #e6f5ef;
  border-color: #009f61;
  background-color: #009f61;
}

.container-buttons .btn-info {
  background: #007dc6;
  color: #fff;
  cursor: pointer;
  padding: 8px 10px;
  font-size: 14px;
  border: none #007dc6;
  border-radius: 5px;
  min-width: 120px;
}

.container-buttons .btn-info:hover {
  color: #e6f5ef;
  border-color: #005088;
  background-color: #005088;
}

.cartorio-pesquisa .el-collapse {
  border: 1px solid #ebeef5;
  border-radius: 10px;
  padding: 0 20px;
  margin: 20px;
}

.cartorio-pesquisa .el-collapse-item__header {
  font-size: 18px;
  font-weight: bold;
  color: #606266;
}

.cartorio-pesquisa .el-collapse-item__header,
.cartorio-pesquisa .el-collapse-item__wrap {
  border: none;
  background-color: transparent !important;
  border-radius: 10px;
}

.cartorio-pesquisa .el-collapse-item__header.focusing:focus:not(:hover) {
  color: #606266;
}

.cartorio-pesquisa .el-collapse:hover {
  box-shadow: 0 2.6px 5.6px rgba(0, 0, 0, 0.029),
    0 5.3px 13px rgba(0, 0, 0, 0.045), 0 9.4px 26.7px rgba(0, 0, 0, 0.061) !important;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/Visualizar.vue